import "./Footer.css";
const Footer = () => {
    return (
        <div className="footer-copyright">
            <p>&copy; 2024 Deepfake Awareness Team. All rights reserved.</p>
        </div>
    );
}

export default Footer;